<template>
    <transition name="registration">
        <div v-if="showRegistration" class="registration-block border-t-dash mt-10">
            <div v-for="(item, key) in touristRegistration.inputs"
                 :key="key"
                 v-show="showRegistrationInput(item)"
                 class="input-wrap">
                <form-input v-if="checkIsInput(item.type)"
                            v-model="item.value"
                            @input="registrationValid()"
                            @focus="changeTabPosition(key + 8)"
                            :type="item.inputType"
                            :valid="item.isValid"
                            :error="item.errorText"
                            :label="localizeList[item.label]"
                            :parent-focus="tabPosition === key + 8"
                            forWhom="registration"/>
                <form-auto-complete v-else
                                    @change="changeRegistrationListByType(item, $event); registrationValid()"
                                    @focus="changeTabPosition(key + 8)"
                                    v-model="item.value"
                                    :items="getRegistrationListByType(item.type)"
                                    :label="localizeList[item.label]"
                                    :valid="item.isValid"
                                    :error="item.errorText"
                                    :parent-focus="tabPosition === key + 8"/>
                <span v-if="item.require" class="require-star">*</span>
            </div>
            <div class="input-wrap">
                <form-text-area v-model="touristRegistration.text.value"
                                v-if="showRegistrationInput(touristRegistration.text.short)"
                                @focus="changeTabPosition(touristRegistration.inputs.length + 8)"
                                :label="localizeList[touristRegistration.text.label]"
                                :parent-focus="tabPosition === touristRegistration.inputs.length + 8"/>
            </div>
            <div class="capcha-wrap align-center justify-between">
                <img :src="touristRegistration.capcha.src" width="150px"/>
                <base-button @click.native="getCaptcha()">
                    <icon name="reload" width="16px" height="16px" fill="var(--white-color)"/>
                </base-button>
            </div>
            <div class="input-wrap">
                <form-input v-model="touristRegistration.capcha.value"
                            @input="checkCaptchaIsFill()"
                            @focus="changeTabPosition(touristRegistration.inputs.length + 9)"
                            :valid="touristRegistration.capcha.isValid"
                            :error="touristRegistration.capcha.errorText"
                            :label="localizeList[touristRegistration.capcha.label]"
                            :parent-focus="tabPosition === touristRegistration.inputs.length + 9"/>
                <span v-if="touristRegistration.capcha.require" class="require-star">*</span>
            </div>
            <div v-show="openLoginModalFromBasket && showAgreeTermsBookingCheckbox"
                 id="clientAgree"
                 class="justify-end mb-6">
                <checkbox small
                          v-model="clientAgree">
                </checkbox>
                <a :href="аgreementAccord"
                   target="_blank"
                   class="blue-text-small">
                    {{localizeList.agreeWithOrderConditions}}
                </a>
            </div>
            <div class="links-wrap">
                <h6 class="grey-text-small mb-3 text-500">{{localizeList.сlickRegistrationAccept}}:</h6>

                <a v-if="submittingAgreePrivacyPolicy && submittingAgreePrivacyPolicy.length"
                   :href="submittingAgreePrivacyPolicy"
                   target="_blank">
                    {{localizeList.submittingAgreePrivacyPolicy}}
                </a>

                <h6 class="grey-text-small mt-3 text-500">{{localizeList.giveConsentSpecifiedPersonsForProcessingPersonalData}}</h6>
            </div>
            <div class="justify-end">
                <base-button @click.native="registration()"
                             :disabled="registrationLoaderStatus"
                             :parent-focus="tabPosition === touristRegistration.inputs.length + 10"
                             padding="10px 48px">
                    <span v-if="!registrationLoaderStatus && !openLoginModalFromBasket" class="login-btn">{{localizeList.registerUpper}}</span>
                    <span v-else-if="!registrationLoaderStatus"
                          class="login-btn">{{localizeList.buyUpper}}</span>
                    <base-loader v-else size="16" weight="5"/>
                </base-button>
            </div>
        </div>
    </transition>
</template>

<script>
    import * as GTM from "@/plugins/GTM.js";
    import {bus} from '../../../main.js'

    export default {
        name: "registration",
        props: {
            tabPosition: {
                type: Number,
                default: 0
            },
            openLoginModalFromBasket: {
                type: Boolean,
                default: false
            },
            showRegistration: {
                type: Boolean,
                default: false
            },
            loginModal: {
                type: Boolean,
                default: false
            },
            submittingAgreePrivacyPolicy: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                API_URL: this.$store.getters['getApiUrl'],
                touristRegistration: {
                    inputs: [
                        {
                            value: "",
                            label: "nameUpper",
                            require: true,
                            isValid: true,
                            errorText: "wrongNameValue",
                            short: true,
                            type: "name",
                            inputType: "text"
                        },
                        {
                            value: "",
                            label: "surnameUpper",
                            require: true,
                            isValid: true,
                            errorText: "wrongSurnameValue",
                            short: true,
                            type: "surname",
                            inputType: "text"
                        },
                        {
                            value: "",
                            label: "phoneNumberUpper",
                            require: true,
                            isValid: true,
                            errorText: "wrongPhoneValue",
                            short: true,
                            type: "phone",
                            inputType: "phone"
                        },
                        {
                            value: "",
                            label: "emailOrLoginUpper",
                            require: true,
                            isValid: true,
                            errorText: "wrongEmailOrLoginValue",
                            short: true,
                            type: "mail",
                            inputType: "mail"
                        },
                        {
                            value: "",
                            label: "passwordUpper",
                            require: true,
                            isValid: true,
                            errorText: "wrongPasswordValue",
                            short: false,
                            type: "password",
                            inputType: "password"
                        },
                        {
                            value: "",
                            label: "passwordConfirmationUpper",
                            require: true,
                            isValid: true,
                            errorText: "wrongPasswordConfirmation",
                            short: false,
                            type: "confirmPassword",
                            inputType: "password"
                        },
                        {
                            value: "",
                            label: "citizenshipUpper",
                            require: true,
                            isValid: true,
                            errorText: "wrongCitizenshipValue",
                            short: false,
                            type: "citizen",
                            inputType: "text"
                        },
                        {
                            value: "",
                            label: "countryUpper",
                            require: false,
                            isValid: true,
                            errorText: "",
                            short: false,
                            type: "country",
                            inputType: "text"
                        },
                        {
                            value: "",
                            label: "cityUpper",
                            require: false,
                            isValid: true,
                            errorText: "",
                            short: false,
                            type: "city",
                            inputType: "text"
                        },
                        {
                            value: "",
                            label: "addressUpper",
                            require: false,
                            isValid: true,
                            errorText: "",
                            short: false,
                            type: "address",
                            inputType: "text"
                        },
                    ],
                    text: {
                        value: "",
                        label: "descriptionUpper",
                        require: false,
                        isValid: true,
                        short: false,
                    },
                    capcha: {
                        value: "",
                        label: "enterCaptchaUpper",
                        require: true,
                        isValid: true,
                        errorText: "wrongCaptchaValue",
                        short: true,
                        sessionId: null,
                        src: ""
                    }
                },
                registrationCountries: [],
                registrationCitizen: [],
                registrationCities: [],
                showAgreeTermsBookingCheckbox: window.settings.showAgreeTermsBookingCheckbox || window.settings.showAgreeTermsBookingCheckbox === undefined,
                clientAgree: false,
                registrationLoaderStatus: false,
                startRegistrationValid: false,
            }
        },
        computed: {
            аgreementAccord() {
                return `${location.origin}${location.pathname}/AgreementAccord.html`;
            },
        },
        created() {
            window.addEventListener("keyup", this.keyup)
        },
        mounted() {
            if (!this.showAgreeTermsBookingCheckbox) {
                this.clientAgree = true
            }
        },
        methods: {
            keyup(e) {
                if (
                    this.loginModal && e.keyCode === 13 &&
                    !this.registrationLoaderStatus &&
                    this.tabPosition === 20
                ) {
                    this.registration()
                }
            },
            getCountriesAndCities() {
                if (this.registrationCountries.length && this.registrationCities.length) return;

                this.$store.dispatch("common/A_GET_COUNTRIES")
                    .then(res => {
                        this.registrationCountries = res.data.map(x => {
                            return {
                                value: x.Key,
                                text: x.Name,
                                isShow: true
                            }
                        });
                        this.registrationCitizen = res.data.map(x => {
                            return {
                                value: x.Key,
                                text: x.Name,
                                isShow: true
                            }
                        });
                    });

                this.getCities(-1);
            },
            getCities(id) {
                this.$store.dispatch("common/A_GET_CITIES", id)
                    .then(res => {
                        const city = this.touristRegistration.inputs.find(x => x.type === "city");
                        const includes = res.data.some(x => x.Key === city.value);
                        if (!includes) {
                            this.touristRegistration.inputs = this.touristRegistration.inputs.map(x => {
                                if (x.type === "city") {
                                    x.value = ""
                                }
                                return x
                            })
                        }
                        this.registrationCities = res.data.map(x => {
                            return {
                                value: x.Key,
                                text: x.Name,
                                isShow: true
                            }
                        })
                    });
            },
            changeTabPosition(i) {
                this.$emit("changeTabPosition", i)
            },
            showRegistrationInput(item) {
                if (!item) return false;

                const simpleRegistration = this.$store.getters['getSettings'].SimpleRegistration;
                const isShowCitizenAuthTourist = this.$store.getters['getSettings'].IsShowCitizenAuthTourist;
                return (item.short || !simpleRegistration && item.type !== "citizen" || (item.type === "citizen" && isShowCitizenAuthTourist))
            },
            getCaptcha() {
                this.$store.dispatch("common/A_GET_CAPTCHA")
                    .then(res => {
                        this.touristRegistration.capcha.sessionId = res.sessionId;
                        this.touristRegistration.capcha.src = res.src
                    })
            },
            setRegistrationFields() {
                const isBasket = this.$route.fullPath.includes('Basket');
                if (!isBasket || !this.showRegistration) return;

                bus.$emit('basket-get-main-tourist-info', info => {
                    const mainTouristInfo = info.filter(x => !x.length);

                    const firstname = mainTouristInfo.find(x2 => x2.code === 'firstname' && x2.value) || mainTouristInfo.find(x2 => x2.code === 'firstnamerus' && x2.value);
                    const lastname = mainTouristInfo.find(x2 => x2.code === 'lastname' && x2.value) || mainTouristInfo.find(x2 => x2.code === 'lastnamerus' && x2.value);
                    const phone = mainTouristInfo.find(x2 => x2.code === 'phone');
                    const email = mainTouristInfo.find(x2 => x2.code === 'email');
                    const citizenship = mainTouristInfo.find(x2 => x2.code === 'citizenship');

                    this.touristRegistration.inputs = this.touristRegistration.inputs.map(x => {
                        if (x.type === 'name' && firstname?.value) {
                            x.value = firstname.value
                        } else if (x.type === 'surname' && lastname?.value) {
                            x.value = lastname.value
                        } else if (x.type === 'phone' && phone?.value) {
                            x.value = phone.value
                        } else if (x.type === 'mail' && email?.value) {
                            x.value = email.value
                        } else if (x.type === 'citizen' && citizenship?.value) {
                            x.value = citizenship.value
                        }

                        return x
                    })
                })
            },
            async correctionField() {
                await this.$nextTick();
                this.touristRegistration.inputs = this.touristRegistration.inputs.map(x => {
                    if (x.type === "phone") {
                        let res = '';
                        for (let i = 0; i < x.value.length; i++) {

                            if (i === 0 && x.value[0] === '+') {
                                res += x.value[i];
                            } else if (!x.value[i].match(/[^0-9]/g)) {
                                res += x.value[i];
                            } else {
                                res += x.value[i].replace(x.value[i], "");
                            }
                        }
                        x.value = res;
                    }
                    return x;
                });
            },
            registrationValid() {
                let valid = true;

                this.correctionField();
                if (!this.startRegistrationValid) {
                    return
                }
                const shortRegistration = this.$store.getters['getSettings'].SimpleRegistration;
                const isShowCitizenAuthTourist = this.$store.getters['getSettings'].IsShowCitizenAuthTourist;

                this.touristRegistration.inputs = this.touristRegistration.inputs.map(x => {
                    if ((shortRegistration && x.short || !shortRegistration) && (x.type !== "citizen" || isShowCitizenAuthTourist)) {
                        if (x.require && !x.value) {
                            x.isValid = false;
                            valid = false
                        } else if (x.require) {
                            x.isValid = true;
                        }

                        if (x.type === "phone") {
                            if (!(x.value.match(/^[\d,+]/) && !isNaN(x.value))) {
                                x.isValid = false;
                                x.errorText = "wrongPhoneMask";
                                valid = false
                            }
                            if (!x.value.length) {
                                x.errorText = "wrongPhoneValue"
                            }
                        }
                        if (x.type === "mail") {
                            const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                            if (!reg.test(String(x.value).toLowerCase())) {
                                x.isValid = false;
                                x.errorText = "wrongEmailOrLoginMask";
                                valid = false
                            }

                            if (!x.value.length) {
                                x.isValid = false;
                                x.errorText = "wrongEmailOrLoginValue"
                            }
                        }
                        if (x.type === "password") {
                            if (
                                !(x.value.match(/[a-z]/) &&
                                    x.value.match(/[A-Z]/) &&
                                    (x.value.match(/[0-9]/) || x.value.match(/[!,@,#,$,%,^,&,*]/)) &&
                                    x.value.length >= 6)
                            ) {
                                x.isValid = false;
                                x.errorText = "passwordDidntAllowedBySecurePolicy";
                                valid = false
                            }
                            if (!x.value.length || x.value.match(/\s/)) {
                                x.isValid = false;
                                x.errorText = "wrongPasswordValue"
                            }
                        }
                        if (x.type === "confirmPassword") {
                            const password = this.touristRegistration.inputs.find(x => x.type === "password");
                            if (x.value !== password.value) {
                                x.isValid = false;
                                x.errorText = "passwordDoesnotEqualsPasswordConfirmation";
                                valid = false
                            }
                            if (!x.value.length) {
                                x.errorText = "wrongPasswordConfirmation"
                            }
                        }
                    }
                    return x
                });
                return valid
            },
            resetForm() {
                this.clientAgree = false;
                this.registrationLoaderStatus = false;
                this.startRegistrationValid = false;
                this.touristRegistration.inputs = this.touristRegistration.inputs.map(x => {
                    x.isValid = true;
                    x.value = "";
                    return x
                });
                this.touristRegistration.text.value = "";
                this.touristRegistration.capcha.isValid = true;
                this.touristRegistration.capcha.value = "";
            },
            registration() {
                this.registrationLoaderStatus = true;
                this.startRegistrationValid = true;
                const formIsFull = this.registrationValid();

                this.checkMail()
                    .then(res => {
                        this.checkCaptcha()
                            .then(res2 => {
                                if (!formIsFull || !res || !res2) {
                                    this.registrationLoaderStatus = false;
                                    return
                                }
                                if (this.openLoginModalFromBasket && !this.clientAgree) {
                                    this.showClientAgreePopup();
                                    this.registrationLoaderStatus = false;
                                    return
                                }

                                const user = {
                                    name: this.touristRegistration.inputs.find(x => x.type === "name").value,
                                    surname: this.touristRegistration.inputs.find(x => x.type === "surname").value,
                                    phone: this.touristRegistration.inputs.find(x => x.type === "phone").value,
                                    login: this.touristRegistration.inputs.find(x => x.type === "mail").value,
                                    password: this.touristRegistration.inputs.find(x => x.type === "password").value,
                                    citizen: this.touristRegistration.inputs.find(x => x.type === "citizen").value,
                                    country: this.touristRegistration.inputs.find(x => x.type === "country").value,
                                    city: this.touristRegistration.inputs.find(x => x.type === "city").value,
                                    address: this.touristRegistration.inputs.find(x => x.type === "address").value,
                                    comment: this.touristRegistration.text.value,
                                    captchaText: this.touristRegistration.capcha.value,
                                    sessionId: this.touristRegistration.capcha.sessionId,
                                };
                                user.phone = encodeURIComponent(user.phone);

                                this.$store.dispatch("tour/A_GET_REGISTRATION_PASSWORD", user)
                                    .then(password => {
                                        // Google Tag Manager
                                        GTM.registration();
                                        // End Google Tag Manager

                                        bus.$emit("login-from-out", {
                                            login: user.login,
                                            password: password
                                        })
                                    })
                            })
                    })
            },
            checkMail() {
                return new Promise((resolve) => {
                    const mailIndex = this.touristRegistration.inputs.map(x => x.type).indexOf("mail");
                    const mail = this.touristRegistration.inputs[mailIndex].value;

                    this.$store.dispatch("common/A_CHECK_MAIL", mail)
                        .then(res => {
                            if (!res.data && mail.length) {
                                this.touristRegistration.inputs[mailIndex].isValid = false;
                                this.touristRegistration.inputs[mailIndex].errorText = "userWithThisEmailOrLoginAlreadyExists";
                            }
                            resolve(res.data)
                        })
                })
            },
            checkCaptcha() {
                return new Promise((resolve) => {
                    const captcha = this.touristRegistration.capcha.value;
                    const sessionId = this.touristRegistration.capcha.sessionId;

                    this.$store.dispatch("common/A_CHECK_CAPTCHA", { captcha, sessionId})
                        .then(res => {
                            this.touristRegistration.capcha.isValid = res.data;
                            resolve(res.data)
                        })
                })
            },
            checkCaptchaIsFill() {
                this.touristRegistration.capcha.isValid = this.touristRegistration.capcha.value.length > 0
            },
            getRegistrationListByType(type) {
                if (type === "country") {
                    return this.registrationCountries
                } else if (type === "citizen") {
                    return this.registrationCitizen
                } else {
                    return this.registrationCities
                }
            },
            changeRegistrationListByType(item, e) {
                this.touristRegistration.inputs = this.touristRegistration.inputs.map(x => {
                    if (x.type === item.type) {
                        x.value = e
                    }
                    return x
                });
                if (item.type === "country") {
                    this.getCities(item.value);
                }
            },
            checkIsInput(type) {
                return (type !== "country" && type !== "city" && type !== "citizen")
            },
            showClientAgreePopup() {
                let rect = document.getElementById('clientAgree').getBoundingClientRect();
                let res = {
                    x: rect.left + (rect.width / 2),
                    y: rect.top,
                    text: this.localizeList.acceptsConditionsNotifyText,
                    height: rect.height
                };
                this.$store.dispatch('A_SHOW_POPOVER', res);
                setTimeout(this.hidePopover, 3000)
            },
        },
        beforeDestroy() {
            window.removeEventListener("keyup", this.keyup);
        },
        watch: {
            touristRegistration: {
                immediate: true,
                handler(val) {
                    this.$emit("changeTouristRegistration", val)
                }
            },
            clientAgree(val) {
                if (val) {
                    bus.$emit('basketClientAgree', val)
                }
            },
            showRegistration(val) {
                if (val) {
                    this.getCaptcha();
                    this.setRegistrationFields();
                }
            },
            loginModal(val) {
                this.setRegistrationFields();

                if (val) {
                    this.getCountriesAndCities()
                } else {
                  this.touristRegistration.inputs = this.touristRegistration.inputs.map(x => {
                      x.isValid = true
                      return x
                  })
                  this.touristRegistration.capcha.isValid = true
                }
            },
        }
    }
</script>

<style scoped>

    .input-wrap {
        position: relative;
        margin: 5px 0 5px;
    }

    .require-star {
        position: absolute;
        top: 5px;
        right: 0;
        color: red;
    }

    .capcha-wrap {
        position: relative;
        margin-top: 20px;
    }

    .capcha-wrap + .input-wrap {
        margin-top: 0;
    }

    .login-btn {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
    }

    .registration-enter-active, .registration-leave-active {
        transition: opacity .5s;
    }

    .registration-enter, .registration-leave-to {
        opacity: 0;
    }

    a.focus {
        outline: #000 auto 1px;
    }

    .links-wrap {
        margin: 20px 0 20px;
    }
    .links-wrap p,
    .links-wrap a {
        font-size: 13px;
        line-height: 16px;
        color: var(--primary-color);
        cursor: pointer;
        display: block;
        text-decoration: underline;
        margin-bottom: 4px;
    }

    /deep/ .authenticated-checkbox.c-checkbox.focus {
        outline: 2px solid black;
    }

</style>